import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, MenuItem, FormControl, InputLabel, Select
} from '@mui/material';

const EstatusModalServ = ({ open, onClose, idCita, estatusActual, onActualizar }) => {
  const [nuevoEstatus, setNuevoEstatus] = useState(estatusActual);
  const nombreDelUsuario = sessionStorage.getItem('Nombre');

  useEffect(() => {
    if (open) {
      setNuevoEstatus(estatusActual);
    }
  }, [open, estatusActual]);

  const handleActualizar = async () => {
    try {
      const response = await fetch('https://bibliotecadlago.com/php/Backend/actualizar_estatusServ.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ IdCita: idCita, Estatus: nuevoEstatus, NombreCambio: nombreDelUsuario })
      });

      const data = await response.json();

      if (data.success) {
        onActualizar(); 
        onClose();
      } else {
        alert(data.message || 'Error al actualizar el estatus');
      }
    } catch (error) {
      alert('Error de conexión con el servidor');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Cambiar Estatus</DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth>
          <InputLabel id="estatus-label">Estatus</InputLabel>
          <Select
            labelId="estatus-label"
            value={nuevoEstatus}
            label="Estatus"
            onChange={(e) => setNuevoEstatus(e.target.value)}
          >
            <MenuItem value="Solicitado">Solicitado</MenuItem>
            <MenuItem value="Confirmada">Confirmada</MenuItem>
            <MenuItem value="En proceso">En proceso</MenuItem>
            <MenuItem value="Finalizado">Finalizado</MenuItem>
            <MenuItem value="Cancelado">Cancelado</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={onClose}>Cancelar</Button>
        <Button variant="contained" sx={{ backgroundColor: 'green', '&:hover': { backgroundColor: '#0b7d0b' } }} onClick={handleActualizar} >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EstatusModalServ;